import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Video {
  name: string;
  api_token: string;
}

export interface VideoDetaiInfor {
  errors: unknown;
  Video: Video;
  isAuthenticated: boolean;
}

@Module
export default class VideoDetail extends VuexModule implements VideoDetaiInfor {
  errors = {};
  Video = {} as Video;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get VideoDetail() {
    return this.videoDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.VIDEO_DETAIL_DATA](Video) {
    this.videoDetailData = Video;
  }
  @Action
  [Actions.VIDEO_DETAIL](payload) {
    return ApiService.getDataDetail("/video", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.VIDEO_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
